module.exports = __webpack_public_path__ + "img/camp_shirt_gk1.c8607411.svg";